import update from 'react-addons-update';

const iState = {
    IsLoading: false,
}

const ShowLoader = (state = iState, action) => {
    switch (action.type) {
        case 'UpdateLoader':
            return update(state, {
                IsLoading: {$set: action.payload.Isloading},
            });
        default:
            return state;
    }
}

export default ShowLoader;